import { enqueueSnackbar } from 'notistack';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { axFetch } from '/@/store/session/actions';

export const generateVisitReportPDF = async ({
    visitReportId,
    language,
}: {
    visitReportId: number;
    language: string;
    fileName?: string;
}) => {
    try {
        const params = new URLSearchParams({
            language,
            visitReportId: visitReportId.toString(),
        });
        enqueueSnackbar(_('Generando PDF...'), {
            variant: 'info',
        });

        const apiUrl = new URL(
            `${settings.urls.apiDomain}/core/v1/fields/visit-reports/${visitReportId}/pdf/?${params.toString()}`,
            window.location.origin
        );

        const response = await axFetch.post(apiUrl.toString(), {});

        return response.data;
    } catch (error) {
        enqueueSnackbar(_('Hubo un error al intentar descargar el PDF'), {
            variant: 'error',
        });
        throw error;
    }
};
